<p-editor class="w-full border-0 border-round-lg border-noround-top" [(ngModel)]="htmlContent"
  (onTextChange)="setContent($event)" [style]="style" name="essayContent" required>
  <ng-template pTemplate="header">
    <!-- Add font family dropdown -->
    <select class="ql-font">
      <option value="serif">Serif</option>
      <option value="sans-serif" selected>Sans-serif</option>
      <option value="monospace">Monospace</option>
    </select>

    <!-- Add font size dropdown -->
    <select class="ql-size">
      <option value="small"></option>
      <option selected></option>
      <option value="large"></option>
      <option value="huge"></option>
    </select>

    <!-- Add font color dropdown -->
    <select class="ql-color">
      <option value="red"></option>
      <option value="green"></option>
      <option value="blue"></option>
      <option value="black" selected></option>
    </select>

    <!-- Add background color dropdown -->
    <select class="ql-background">
      <option value="yellow"></option>
      <option value="pink"></option>
      <option value="lightblue"></option>
      <option value="transparent" selected></option>
    </select>

    <!-- Add text alignment buttons -->
    <span class="ql-formats">
      <button type="button" class="ql-bold" aria-label="Bold"></button>
      <button type="button" class="ql-italic" aria-label="Italic"></button>
      <button type="button" class="ql-underline" aria-label="Underline"></button>
      <button type="button" class="ql-align" aria-label="Align Justify" value="justify"></button>
      <button type="button" class="ql-align" aria-label="Align Center" value="center"></button>
      <button type="button" class="ql-align" aria-label="Align Right" value="right"></button>
    </span>

    <!-- Add bullet and numbered list buttons -->
    <span class="ql-formats">
      <button type="button" class="ql-list" aria-label="Bullet List" value="bullet"></button>
      <button type="button" class="ql-list" aria-label="Numbered List" value="ordered"></button>
    </span>
  </ng-template>
</p-editor>
